<template>
  <div id="tab3" class="tab active">
    <!-- <Popup v-if="selectedImage" :image="selectedImage">
           
           </Popup> -->
    <isotope
      :list="list"
      id="root_isotope"
      class="isoDefault"
      :options="option"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="item.extra"
        :style="{ 'background-color': item.color }"
      >
        <a @click="selectedImage = item.original">
          <span
            :class="'inner ' + item.show"
            :style="{ 'background-color': item.color }"
          >
            <h1>{{ item.title }}</h1>
            <p>{{ item.desc }}</p>
          </span>
          <img :src="item.image" />
        </a>
      </div>
    </isotope>
    <hire />
  </div>
</template>

<script>
import isotope from "vueisotope";

export default {
  components: { isotope },
  data() {
    return {
      selectedImage: "",
      list: [
        // {
        //   image: "/img/gallery/mm/18.jpg",
        //   original: "/img/gallery/mm/18.jpg",
        //   title: "Jadu",
        //   desc: "Jadu bhut bada",
        //   color: "#000"
        // },
        {
          image: "/img/gallery/mm/18.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D7D7D7",
        },
        {
          image: "/img/gallery/mm/14.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#64B6D6",
        },
        {
          image: "/img/gallery/mm/16.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#828E92",
        },
        {
          image: "/img/gallery/mm/10.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D5DADD",
        },
        {
          image: "/img/gallery/mm/3.jpg",
          title: "Pune, Maharashtra",
          desc: "Hyatt Regency",
          color: "#2B2941",
          extra: "item-2x",
          show: "innershow",
        },
        {
          image: "/img/gallery/mm/2.jpg",
          title: "Delhi Theme",
          desc: "",
          color: "#E0C5AB",
          show: "innershow",
        },
        {
          image: "/img/gallery/mm/9.jpg",
          title: "Varanasi Ghat",
          desc: "",
          color: "#5D3F20",
          show: "innershow",
        },
        {
          image: "/img/gallery/mm/12.jpg",
          title: "Ahmedabad",
          desc: "Novetel",
          color: "#b2aa9b ",
          extra: "item-2x",
          show: "innershow",
        },
        {
          image: "/img/gallery/mm/7.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2f2f2f",
        },
        {
          image: "/img/gallery/mm/8.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#666F7C",
        },
        {
          image: "/img/gallery/mm/5.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#DB9E53",
          extra: "item-h2x",
        },
        {
          image: "/img/gallery/mm/4.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#EAC5A5",
        },
        {
          image: "/img/gallery/mm/6.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#EED8B6",
        },
        {
          image: "/img/gallery/mm/1.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E1CFC4",
          extra: "item-h3x",
        },
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },
};
</script>
